import useInfiniteScroll from "../../../../hooks/useInfiniteScroll";
import React, { FC, useState, useEffect, memo, useMemo } from "../../../../lib/teact/teact";
import Button from "../../../ui/Button";
import InfiniteScroll from "../../../ui/InfiniteScroll";
import ListItem from "../../../ui/ListItem";
import SearchInput from "../../../ui/SearchInput";
import { CongNoApi } from "../../restapi/congNoApi";
import { tienFormat } from "../../utils/NumberUtils";
import NhapSuaChungTu from "./nhapSuaChungTu";
import './congNoTongHop.scss'
type OwnProps = {
    onNhapChungTu: (props: any) => void;
    onContactIdClicked: (contactId: number) => void
}

const CongNoTongHop: FC<OwnProps> = ({
    onNhapChungTu,
    onContactIdClicked,
}) => {
    const [state, setState] = useState({
        congNo: [] as any[],
        nhapCongNo: {
            isOpen: false,
            chungTu: undefined as any,
            ctype: "",

        },
        reload: new Date(),
    })
    useEffect(() => {
        CongNoApi.GetCongNoTongHop().then(res => {
            if (res.data) {
                setState(prev => ({ ...prev, congNo: res.data }))
            }
        })
    }, [state.reload])
    function handleNhapCongNoClose() {
        const tmp = { ...state.nhapCongNo }
        tmp.isOpen = false;
        setState(prev => ({ ...prev, nhapCongNo: tmp }))
    }
    const listIds = useMemo(() => {
        const result: number[] = []
        const len = state.congNo.length;
        for (let i = 0; i < len; i++) {
            result.push(i)
        }
        return result
    }, [state.congNo]);
    const [viewportIds, getMore] = useInfiniteScroll(undefined, listIds, false, 50, undefined);
    function handleOnReload() {
        setState(prev => ({ ...prev, reload: new Date() }))
    }
    function NhapMoiChungTu(ctype: 'thu' | 'bu' | 'phaithu' | 'phaitra', contactId: number) {
        CongNoApi.GetTempleteNhapChungTu({ contactId: contactId }).then(res => {
            if (res.data) {
                const tmp = { ...state.nhapCongNo }
                tmp.chungTu = res.data

                tmp.isOpen = true
                tmp.chungTu.ngay = tmp.chungTu.ngay.substring(0, 10)
                tmp.ctype = ctype
                switch (ctype) {
                    case 'thu':
                        tmp.chungTu.tkNo = "111"
                        tmp.chungTu.tkCo = "131"
                        break;
                    case 'bu':
                        tmp.chungTu.tkNo = "131"
                        tmp.chungTu.tkCo = "111"
                        break;
                    case 'phaitra':
                        tmp.chungTu.tkNo = ""
                        tmp.chungTu.tkCo = "131"
                        break;
                    case 'phaithu':
                        tmp.chungTu.tkNo = "131"
                        tmp.chungTu.tkCo = ""
                        break;
                }

                setState(prev => ({ ...prev, nhapCongNo: tmp }))
            }
        })
    }
    function getCongNo(it: any): number {
        let congNo: number = it.phaiThu - it.daThu - it.phaiTra + it.daTra;
        return congNo;
    }
    return (
        <div className=" form-content">
            <div className=" form-header">
                <div className=" form-header left-panel">
                    <SearchInput
                        onChange={() => { }}></SearchInput>
                </div>
                {/* <div className=" form-header right-panel">
                    <Button round size='tiny'><i className=" icon icon-document"></i></Button>
                </div> */}
            </div>
            <div className=" form-content with-search">
                <InfiniteScroll
                    items={viewportIds} onLoadMore={getMore} className="chat-list custom-scroll"

                >
                    {
                        listIds.map((item: any, index: number) => {
                            const it = state.congNo[index];
                            const congNo = getCongNo(it)
                            return <div key={"ct" + index} style ='padding: 10px 0 10px 0;'>

                                <ListItem
                                    contextActions={[
                                        {
                                            handler: () => {
                                                NhapMoiChungTu("thu", it.contactId)
                                            },
                                            title: "Thu tiền",
                                            icon: "document"
                                        },
                                        {
                                            handler: () => {
                                                NhapMoiChungTu("bu", it.contactId)
                                            },
                                            title: "Bù tiền",
                                            icon: "stop"
                                        },
                                        {
                                            handler: () => {
                                                NhapMoiChungTu("phaithu", it.contactId)
                                            },
                                            title: "Tiền phải thu (chưa thu)",
                                            icon: "stop"
                                        },
                                        {
                                            handler: () => {
                                                NhapMoiChungTu("phaitra", it.contactId)
                                            },
                                            title: "Tiền phải trả (chưa trả)",
                                            icon: "document"
                                        },
                                    ]}
                                    onClick={() => { onContactIdClicked(it.contactId) }}
                                >
                                    <div className=" common-container-row">
                                        <div className=" common-container-row left-panel">
                                            <div className="name">{it.name}</div>

                                        </div>
                                        <div className={(congNo >= 0 ? "phaiThu" : "phaiTra") + " common-container-row right-panel "}>{tienFormat(congNo, 1)}</div>

                                    </div>
                                </ListItem>
                            </div>
                        })
                    }
                </InfiniteScroll>
            </div>
            <NhapSuaChungTu
                onDataSaved={handleOnReload}
                onClose={handleNhapCongNoClose}
                data={state.nhapCongNo}
                isOpen={state.nhapCongNo.isOpen}></NhapSuaChungTu>
        </div>
    )
}

export default memo(CongNoTongHop)